<!-- -------------------------------------------------------------------------------------------------------- -->
<!-- This is the default component for rendering the Duty activity title                                      -->
<!-- -------------------------------------------------------------------------------------------------------- -->
<template>
  <div class="d-flex DutyActivityTitle_Default">
    <div class="d-flex flex-grow-1 align-center" style="height: 30px">
      <h3 v-if="hasTrueChildren">Kurs {{ dutyActivity.blockcode }} {{ isNaN(dutyActivity.blockcode) ? lineNextToBlockcodeTitle : '' }}</h3>
      <v-btn v-if="!isNaN(dutyActivity.blockcode) && showAllTracksBtn" class="caption" text rounded x-small @click.prevent.stop="onSelect"
        >{{ $t(selectAllLine ? 'fd.showCompleteTrack' : 'fd.showDutyActivity') }}
      </v-btn>
    </div>

    <duty-activity-type-icon v-if="showActivityTypeIcon" :dutyActivity="dutyActivity"></duty-activity-type-icon>
    <duty-activity-json v-if="showTitleJsonHint" :dutyActivity="dutyActivity"></duty-activity-json>
  </div>
</template>

<script>
import commonMixin from '@/mixins/common';
import DutyActivityTypeIcon from '../../components/DutyActivityTypeIcon.vue';
import DutyActivityJson from '../../components/DutyActivityJson.vue';

export default {
  name: 'DutyActivityTitle_Default',
  mixins: [commonMixin],

  props: {
    duty: Object,
    dutyActivity: Object,
    config: Object,
    showAllTracksBtn: { type: Boolean, default: false },
    hasTrueChildren: { type: Boolean, default: false },
  },
  components: {
    DutyActivityJson,
    DutyActivityTypeIcon,
  },
  data() {
    return {
      selectAllLine: true,
    };
  },
  computed: {
    lineNextToBlockcodeTitle() {
      let lineNextToBlockcodeTitle = this.config.showLineNextToBlockcodeTitle;
      return this.dutyActivity.line && lineNextToBlockcodeTitle ? ` / Linie ${this.dutyActivity.line}` : '';
    },
    showTitleJsonHint() {
      return this.config.showTitleJsonHint;
    },
    showActivityTypeIcon() {
      return this.config.showActivityTypeIcon;
    },
  },
  methods: {
    onSelect() {
      // console.debug('selectAllLine', this.selectAllLine);
      this.selectAllLine = !this.selectAllLine;
      if (this.selectAllLine) {
        this.$emit('onSelectDutyActivity');
      } else {
        this.$emit('onSelectAllLine');
      }
    },
  },
};
</script>
